import styled from 'styled-components';

export const StyledFooter = styled.footer`
	width: 100%;
	background: black;
	font-family: Arial, Helvetica, sans-serif;
	font-size: 1rem;
	text-align: center;
	color: white;
	height: 7vh;
	line-height: 7vh;
`;

export const StyledLink = styled.a`color: #40a1f2;`;
